import { BsBookmarkCheckFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import {
  convertToCamelCase,
  CUSTOMER_TYPE_ICON,
  ICON_OCT_VERIFIED,
  ICON_PROJECT_SIZE,
  PROJECT_CATEGORY_ICON,
  PROPERTY_TYPE_ICONS,
} from "src/helpers";
import { CELL_ROUTES } from "src/navigations/CellRoutes";
import { MAIN_ROUTES_CONST } from "src/navigations/modules";

type Props = {
  projects: Array<any>;
  loading: boolean;
};

type RenderItemProps = {
  projectName: string;
  _id: string;
  projectSize: string;
  customerType: string;
  projectCategoryType: string;
  projectType: string;
  systemType: string;
  totalProjectCost: string;
  returnPerYearRate: string;
  headerImage: any;
  termPlan: string;
  projectId: string;
  imageAttachments: string[];
  requiredInvestment: string;
  totalInvestmentValue: string;
  buildingType: string;
  state: string;
  nearestCity: string;
  currentElectricityTariff: string;
};

const RenderItem = ({
  projectName,
  _id,
  projectSize,
  projectType,
  systemType,
  totalProjectCost,
  headerImage,
  returnPerYearRate,
  termPlan,
  projectId,
  imageAttachments,
  requiredInvestment,
  totalInvestmentValue,
  buildingType,
  customerType,
  projectCategoryType,
  state,
  nearestCity,
  currentElectricityTariff,
}: RenderItemProps) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate("/" + MAIN_ROUTES_CONST.cell + "/" + CELL_ROUTES.details + "/" + _id)}
      className="w-full md:w-100 md:min-h-[230px] min-h-[490px] grid md:grid-cols-4 gap-2 md:gap-4  border-2 border-gray-200 hover:shadow-md cursor-pointer rounded-2xl overflow-hidden transition duration-300 ease-in-out hover:scale-[1.01] "
    >
      <div className=" relative md:h-full" style={{ width: "100%" }}>
        <img
          //   style={{ width: "100%", height: "100%" }}
          src={imageAttachments?.length > 0 ? imageAttachments[0] : ""}
          className="w-full md:h-full h-[150px]"
          alt="imageAttachments"
        />
        <div className="absolute bottom-2  md:bottom-2 right-2">
          {" "}
          <img src={ICON_OCT_VERIFIED} style={{ height: "32px" }} alt="ICON_OCT_VERIFIED" />
        </div>
      </div>
      <div className="md:col-span-3 space-y-6 p-4 ">
        <div className="flex md:flex-row flex-col md:justify-between space-y-2 md:space-y-0">
          <div className="flex flex-col">
            <span className="font-bold uppercase text-primary">
              # {projectId} {currentElectricityTariff ? "Tariff : " + currentElectricityTariff : " "}
            </span>
            <div className="flex space-x-2 items-center">
              <span>
                <BsBookmarkCheckFill size={16} className="text-primary" />
              </span>
              <div className="flex items-center space-x-2">
                {/* {Number(totalInvestmentValue) == 0 ? ( */}
                <span className="rounded-full bg-green-600 font-semibold text-[8px] py-[2px] px-[6px]  text-white uppercase ">
                  New
                </span>
                {/* ) : (
                  <span className="rounded-full bg-red-600 font-semibold text-[8px] py-[2px] px-[6px] text-white uppercase">
                    In-Progress
                  </span>
                )} */}
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="text-xs flex space-x-2">
              <div>
                {nearestCity ? `${nearestCity}, ` : ""}
                {state}
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-4 grid-cols-2  md:gap-4 gap-x-4 gap-y-8 md:gap-y-0">
          <div className=" items-center space-y-1.5 px-4">
            <div className=" flex justify-center item-center">
              <img src={ICON_PROJECT_SIZE} style={{ height: "32px" }} alt="ICON_PROJECT_SIZE" />
            </div>
            <div className="text-xs text-center">Project Size</div>
            <div className=" font-bold text-sm text-center">{projectSize}</div>
          </div>
          <div className=" items-center space-y-1.5 px-4">
            <div className=" flex justify-center item-center">
              <img
                src={PROPERTY_TYPE_ICONS[projectType as keyof object]}
                style={{ height: "32px" }}
                alt="PROPERTY_TYPE_ICONS"
              />
            </div>
            <div className="text-xs text-center">Project Type </div>
            <div className=" font-bold text-sm text-center">
              {" "}
              {convertToCamelCase(projectType?.toLocaleLowerCase())}
            </div>
          </div>
          <div className=" items-center space-y-1.5 px-4">
            <div className=" flex justify-center item-center">
              <img
                src={CUSTOMER_TYPE_ICON[customerType as keyof object]}
                style={{ height: "32px" }}
                alt="CUSTOMER_TYPE_ICON"
              />
            </div>
            <div className="text-xs text-center">Project Category </div>
            <div className="font-bold text-sm text-center "> {customerType}</div>
          </div>
          <div className=" items-center space-y-1.5 px-4">
            <div className=" flex justify-center item-center">
              <img
                src={PROJECT_CATEGORY_ICON[projectCategoryType as keyof object]}
                style={{ height: "32px" }}
                alt="PROJECT_CATEGORY_ICON"
              />
            </div>
            <div className="text-xs text-center">Service Type </div>
            <div className=" font-bold text-sm text-center"> {projectCategoryType}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ResultFilter = ({ projects, loading }: Props) => {
  return (
    <div className="flex flex-col space-y-2">
      {projects?.length > 0 &&
        projects?.map((project: any) => {
          return <RenderItem {...project} />;
        })}
    </div>
  );
};

export default ResultFilter;
